export enum RoleAccessStatus {
  unknown,
  canPlay,
  shouldIdentify,
  shouldSubscribe,
  shouldBeQRHost,
}
